import { render, staticRenderFns } from "./AuthorizationNotification.vue?vue&type=template&id=c018d494&"
import script from "./AuthorizationNotification.vue?vue&type=script&lang=js&"
export * from "./AuthorizationNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports